  (function($){

    var c = {
      init: function(){
        $(".copy-value-button").click( c.copyText );
      },
      copyText: function(ev){
        ev.preventDefault();
        new ClipboardJS('.copy-value-button');
        $(this).toggleClass("shake-effect");
        $(this).text( $(this).data("success-text") );
      }
    };

    c.init();

  })(jQuery);
